import { Help, Lifesaver } from '@carbon/icons-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SupportOptionsWrapper } from 'components/MainLayout/styled';
import { ServiceStatusOption } from 'components/ServiceStatusOption';
import { SupportOption } from 'components/SupportOption';

export function SupportOptions(): JSX.Element {
  const [t, { language }] = useTranslation();

  return (
    <SupportOptionsWrapper>
      <ServiceStatusOption />
      <SupportOption
        href="https://rescue.app.tablecheck.com/"
        icon={<Lifesaver size={32} />}
        label={t('labels.rescue_app')}
      />
      <SupportOption
        href={`https://support-restaurants.tablecheck.com/hc/${
          language === 'ja' ? 'ja' : 'en-us'
        }`}
        icon={<Help size={32} />}
        label={t('labels.support')}
      />
    </SupportOptionsWrapper>
  );
}
